import { useState, useEffect } from 'react';
import apiService from '../services/apiService';
import { ExpensesByCategoryData } from '../types';
import { getMonthDateRange } from '../utils/formatters';

export const useCategoryExpenses = (currency: string, selectedDate: Date) => {
  const [categoryExpenses, setCategoryExpenses] = useState<ExpensesByCategoryData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let cancelled = false;

    const loadCategoryExpenses = async () => {
      try {
        setLoading(true);
        setError(null);
        const { startDate, endDate } = getMonthDateRange(selectedDate);
        const data = await apiService.getExpensesByCategory(currency, startDate, endDate);
        if (!cancelled) {
          setCategoryExpenses(data);
        }
      } catch (err: any) {
        if (cancelled || err?.name === 'CanceledError' || err?.code === 'ERR_CANCELED') return;
        setError(err as Error);
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    loadCategoryExpenses();

    return () => {
      cancelled = true;
    };
  }, [currency, selectedDate]);

  const reload = async () => {
    try {
      setLoading(true);
      setError(null);
      const { startDate, endDate } = getMonthDateRange(selectedDate);
      const data = await apiService.getExpensesByCategory(currency, startDate, endDate);
      setCategoryExpenses(data);
    } catch (err: any) {
      if (err?.name === 'CanceledError' || err?.code === 'ERR_CANCELED') return;
      setError(err as Error);
    } finally {
      setLoading(false);
    }
  };

  return { categoryExpenses, loading, error, reload };
};
